import React, { useState, useEffect } from "react";
import { fetchOne } from "../utils/fetchResources";
import { useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { onReadyCKE, CKEconfig } from "../config/CKE";
import { useSnackbar } from "notistack";
import {
	makeStyles,
	Typography,
	TextField,
	Button,
	Grid,
	Card,
	CardContent,
	Hidden,
	useTheme,
} from "@material-ui/core";
import SetFile from "../components/SetFile";

function ExternalSitesEdit(props) {
	const theme = useTheme();
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [externalSite, setExternalSite] = useState();
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		(async () => {
			await fetchOne("externalsites", id, setExternalSite);
			setLoading(false);
		})();
	}, [id]);

	const onSubmit = (e) => {
		e.preventDefault();
		fetch(`${process.env.REACT_APP_API_URL}/externalsites/${id}`, {
			method: "PUT",
			credentials: "include",
			body: JSON.stringify(externalSite),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				if (data.success) {
					enqueueSnackbar("External Site updated successfully!", {
						variant: "success",
					});
					fetchOne("externalsites", id, setExternalSite);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	const onChange = (e) => {
		setExternalSite({ ...externalSite, [e.target.name]: e.target.value });
	};

	const onChangeDescription = (e, editor) => {
		const data = editor.getData();
		setExternalSite({ ...externalSite, description: data });
	};

	const useStyles = makeStyles((theme) => ({
		paper: {
			marginTop: theme.spacing(8),
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		form: {
			width: "100%", // Fix IE 11 issue.
		},
		submit: {
			margin: theme.spacing(2, 0, 1),
		},
		CKElabels: {
			marginTop: "1.5rem",
			fontWeight: "bold",
		},
		colorSettings: {
			listStyleType: "none",
			marginTop: "1rem",
			padding: 0,
			"& li": {
				margin: ".5rem 0",
			},
		},
		colorLabel: {
			marginLeft: ".5rem",
		},
	}));

	const classes = useStyles();

	if (loading || !externalSite) {
		return <div>Loading...</div>;
	}

	return (
		<form className={classes.form} onSubmit={onSubmit}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={12} md={9}>
					<Typography component="h1" variant="h4">
						Edit Site:{" "}
						<a
							style={{ color: theme.palette.primary.main }}
							href={externalSite.url}
							target="_blank"
							rel="noreferrer"
						>
							{externalSite.name}
						</a>
					</Typography>
					<TextField
						variant="outlined"
						margin="normal"
						fullWidth
						id="name"
						label="Site Name"
						name="name"
						size="small"
						required
						onChange={onChange}
						value={externalSite.name}
					/>
					<TextField
						type="url"
						variant="outlined"
						margin="normal"
						fullWidth
						required
						id="url"
						label="URL"
						name="url"
						size="small"
						onChange={onChange}
						value={externalSite.url}
					/>
					<p className={classes.CKElabels}>Description*:</p>
					<CKEditor
						onReady={(editor) => {
							onReadyCKE(editor);
						}}
						editor={Editor}
						onChange={onChangeDescription}
						data={externalSite.description}
						config={CKEconfig("Sho...externalSite description...")}
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						className={classes.submit}
					>
						Save
					</Button>
				</Grid>
				<Grid item xs={12} sm={12} md={3}>
					<Card>
						<CardContent>
							<Hidden smDown>
								<Button
									type="submit"
									onClick={onSubmit}
									fullWidth
									variant="contained"
									color="primary"
									className={classes.submit}
								>
									Save
								</Button>
							</Hidden>
							<SetFile
								fileTitle="Featured Image"
								resource={externalSite}
								setResource={setExternalSite}
								imageOnly={true}
								fileLabel="featuredImage"
								fileLabelFileName="featuredImageFile"
							/>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</form>
	);
}

export default ExternalSitesEdit;
